import Vue from 'vue'

const shopifyStores = {
  namespaced: true,
  state: {
    stores:[]
  },
  mutations: {
    FETCH_STORES (state, stores) {
      state.stores = stores
    }
  },
  actions: {
    getShopifyStores ({state, commit}) {
      if (state.current === undefined) {
        Vue.axios.get(process.env.VUE_APP_API_URL + 'shopify/customer-stores')
          .then((response) => {
            commit('FETCH_STORES', response.data)
          })
          .catch(error => {
            console.log(error.statusText)
          })
      } else {
        return commit('FETCH_STORES', state.current)
      }
    }
  }
}

export default shopifyStores
